import * as actionTypes from 'actions';
import { ENTITY_TYPES } from 'common/constants';

const initialState = {
  saved: false,
  savedShortUrl: {},
  deleted: false,
  deletedShortUrl: {},
  shortUrl: {
    creationId: null,
    name: '',
    shortCode: '',
    phoneNumber: '',
    emailAddress: '',
    address: '',
    capacity: '',
    type: null,
    description: ''
  },
  entityPhotos: [],
  customers: [],
  validationMessages: {}
};

const shortUrlCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_SHORT_URL_FULFILLED: {
      return {
        ...state,
        saved: action.payload.data.success,
        savedShortUrl: action.payload.data.result,
        validationMessages: action.payload.data.validationMessages
      };
    }

    case actionTypes.DELETE_SHORT_URL_FULFILLED: {
      return {
        ...state,
        deleted: action.payload.data.success,
        deletedShortUrl: action.payload.data.result
      };
    }

    case actionTypes.EDIT_SHORT_URL_FULFILLED: {
      return {
        ...state,
        shortUrl: {
          ...action.payload.data.result,
          identifiersCreated: true
        }
      };
    }

    case actionTypes.CREATE_SHORT_URL_VALUE_RESET: {
      return {
        ...initialState
      };
    }

    case actionTypes.CREATE_SHORT_URL_VALUE_UPDATE: {
      return {
        ...state,
        shortUrl: {
          ...state.shortUrl,
          ...action.payload
        }
      };
    }

    case actionTypes.FIND_CUSTOMERS_PENDING: {
      return {
        ...state,
        customers: initialState.customers
      };
    }

    case actionTypes.FIND_CUSTOMERS_FULFILLED: {
      return {
        ...state,
        customers: action.payload.data
      };
    }

    case actionTypes.CREATE_ENTITY_PHOTO_FULFILLED: {
      const entityPhoto = action.payload.data.result;
      let result;

      if (
        entityPhoto.entityType === ENTITY_TYPES.SHORT_URL &&
        (entityPhoto.entityId === state.shortUrl.id ||
          entityPhoto.entityTempId === state.shortUrl.creationId)
      ) {
        const entityPhotos = state.entityPhotos.slice();
        entityPhotos.push(entityPhoto);

        return {
          ...state,
          entityPhotos: entityPhotos
        };
      } else {
        result = state;
      }
      return result;
    }

    case actionTypes.DELETE_ENTITY_PHOTO_FULFILLED: {
      const entityPhoto = action.payload.data.result;
      let result;

      if (
        entityPhoto.entityType === ENTITY_TYPES.SHORT_URL &&
        (entityPhoto.entityId === state.shortUrl.id ||
          entityPhoto.entityTempId === state.shortUrl.creationId)
      ) {
        const photoIndex = state.entityPhotos
          .map(photo => photo.id)
          .indexOf(entityPhoto.id);

        const entityPhotos = state.entityPhotos.slice();
        entityPhotos.splice(photoIndex, 1);

        return {
          ...state,
          entityPhotos: entityPhotos
        };
      } else {
        result = state;
      }
      return result;
    }

    case actionTypes.SAVE_ENTITY_PHOTO_FULFILLED: {
      const entityPhoto = action.payload.data.result;
      let result;

      if (
        entityPhoto.entityType === ENTITY_TYPES.SHORT_URL &&
        (entityPhoto.entityId === state.shortUrl.id ||
          entityPhoto.entityTempId === state.shortUrl.creationId)
      ) {
        const photoIndex = state.entityPhotos
          .map(photo => photo.id)
          .indexOf(entityPhoto.id);

        const entityPhotos = state.entityPhotos.slice();
        entityPhotos[photoIndex] = action.payload.data.result;

        return {
          ...state,
          entityPhotos: entityPhotos
        };
      } else {
        result = state;
      }
      return result;
    }

    case actionTypes.FIND_ENTITY_PHOTOS_FULFILLED: {
      return {
        ...state,
        shortUrlLoading: false,
        entityPhotos: action.payload.data.result
      };
    }

    default: {
      return state;
    }
  }
};

export default shortUrlCreateReducer;
